// Platform detection helpers.
//
// On iOS, Apple's App Store guideline 3.1.1 forbids selling digital
// subscriptions via any payment mechanism other than In-App Purchase.
// We don't sell IAP, so the iOS build must hide all paywall surfaces
// (pricing, Subscribe / Upgrade buttons, the Subscription page, promo
// codes, Stripe checkout, etc.). Users sign up & manage billing on the
// website; the iOS app is sign-in-only.

declare global {
  interface Window {
    Capacitor?: {
      getPlatform?: () => string;
      isNativePlatform?: () => boolean;
    };
  }
}

export const isNativeApp = (): boolean => {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
  return true;
};

export const getPlatform = (): "ios" | "android" | "web" => {
  if (typeof window === "undefined") return "web";
  const p = window.Capacitor?.getPlatform?.();
  if (p === "ios" || p === "android") return p;
  return "web";
};

export const isIOSNative = (): boolean => getPlatform() === "ios";

// Anywhere paywall / subscription UI should be hidden because Apple
// won't accept it. Currently iOS only — Android & web behave normally.
export const hidePaywallUI = (): boolean => isIOSNative();
